export const FETCH_PUBLISHERS_LIST = 'FETCH_PUBLISHERS_LIST';
export const FETCHED_PUBLISHERS_LIST = 'FETCHED_PUBLISHERS_LIST';
export const SET_PUBLISHERS_FILTER = 'SET_PUBLISHERS_FILTER';

export const FETCH_CATEGORIES_LIST = 'FETCH_CATEGORIES_LIST';
export const FETCHED_CATEGORIES_LIST = 'FETCHED_CATEGORIES_LIST';
export const SET_CATEGORIES_FILTER = 'SET_CATEGORIES_FILTER';

export const FETCH_KEYWORDS_LIST = 'FETCH_KEYWORDS_LIST';
export const FETCHED_KEYWORDS_LIST = 'FETCHED_KEYWORDS_LIST';
export const SET_KEYWORDS_FILTER = 'SET_KEYWORDS_FILTER';

export const FETCH_BRANDS_LIST = 'FETCH_BRANDS_LIST';
export const FETCHED_BRANDS_LIST = 'FETCHED_BRANDS_LIST';
export const SET_BRANDS_FILTER = 'SET_BRANDS_FILTER';

export const FETCH_HUBS_LIST = 'FETCH_HUBS_LIST';
export const FETCHED_HUBS_LIST = 'FETCHED_HUBS_LIST';
export const SET_HUBS_FILTER = 'SET_HUBS_FILTER';

export const SAVE_RICH_PUBLISHER_DATA = 'SAVE_RICH_PUBLISHER_DATA';
export const SAVE_RICH_BRAND_DATA = 'SAVE_RICH_BRAND_DATA';
export const REMOVE_RICH_PUBLISHER_DATA = 'REMOVE_RICH_PUBLISHER_DATA';
export const REMOVE_RICH_BRAND_DATA = 'REMOVE_RICH_BRAND_DATA';

// import { FETCH_CATEGORIES_LIST, FETCHED_CATEGORIES_LIST } from 'components/Global/Filters/actions.js';
